import { useValidation } from 'hooks/useValidation';
import { FormTextArea } from 'components/form-fields';
import React, { useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export function OcrTextareaLayout(
    {
        disabled = false,
        loading = false,
        layout,
        onChange,
        readonly
    }
) {
    const [_, errors, validate] = useValidation();

    useEffect(() => {
        validateLayout();
    }, [layout.answer]);

    function validateLayout() {
        const rules = getRules();
        validate(rules, layout);
    }

    function getRules() {
        const isRequired = layout.requiredAnswerCount > 0;
        return [{ fieldName: 'answer', required: isRequired }];
    }

    function onValueChange(event) {
        const layoutClone = { ...layout };

        layoutClone.answer = event.target.value;

        onChange(layoutClone);
    }

    return (
        <Fragment>
            <div className={classNames({ "hide-in-print": !readonly, "hidden": readonly })}>
                <FormTextArea
                    loading={loading}
                    disabled={disabled}
                    headingText={layout.secondaryLayoutTitle}
                    onChange={onValueChange}
                    dangerHelperText={errors.answer}
                    value={layout.answer ? layout.answer : ''}
                    maxLength={2000}
                    wide
                    expandable
                />
            </div>
            <p className={classNames({ "show-in-print": !readonly, "visible": readonly, "bp6-skeleton": loading }, "preserve-white-space")}>{layout.answer ? layout.answer : 'None'}</p>
        </Fragment>
    );
}

OcrTextareaLayout.propTypes = {
    onChange: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    layout: PropTypes.object.isRequired,
    disabled: PropTypes.bool
};
